import '../../css/pages/gasstrut.scss';
import { scrollIntoView } from '../modules/scroll-into-view/scroll-into-view';
import SetupReadmore from '../modules/readmore/readmore';
import { isMobile } from '../modules/mobile-detect/mobile-detect';
import { gaTracking } from '../modules/event/event';
import loadComponentCarousel from "../modules/component-carousel/load-component-carousel";

const init = async () => {
    console.log('Gas Strut init');
    SetupReadmore();
    handleNumberInputs();

    const nextButtons = document.querySelectorAll('.js-next-form-step') as NodeListOf<HTMLButtonElement>;
    nextButtons?.forEach(btn => {
        btn.addEventListener('click', e => {
            e.preventDefault();
            validateStep(btn);
        });
    });
    rodEndFixingOptions();
    formSubmission();
    toggleSummary();
    loadComponentCarousel();
};

const validateStep = (btn: HTMLButtonElement) => {
    const container = btn.closest('.SGS-card') as HTMLElement;
    const inputs = container.querySelectorAll('input:not(.optional)') as NodeListOf<HTMLInputElement>;
    const hasRadios = container.querySelectorAll('input[type="radio"]') as NodeListOf<HTMLInputElement>;
    let radiosCheck = false;

    inputs?.forEach(input => {
        const errorElem = input.parentElement.classList.contains('custom-select') ? input.parentElement as HTMLElement : input;
        if ((input.value === '' || input.value.length > 4 || parseInt(input.value) < 0) && input.required)
            errorElem.classList.add('is-invalid');  
        else errorElem.classList.remove('is-invalid');
    });
    

    if (hasRadios && hasRadios.length > 0) {
        const checkedRadios = container.querySelectorAll('input[type="radio"]:checked') as NodeListOf<HTMLInputElement>;
        if (checkedRadios.length === 0) {
            hasRadios.forEach(radio => {
                const errorElem = radio.parentElement.parentElement;
                errorElem.classList.add('is-invalid');
            });
        }
        else {
            hasRadios.forEach(radio => {
                const errorElem = radio.parentElement.parentElement;
                errorElem.classList.remove('is-invalid');
            });
            radiosCheck = true;
        }
    } else radiosCheck = true;

    const invalidInputs = container.querySelectorAll('input.is-invalid') as NodeListOf<HTMLInputElement>;
    if (invalidInputs.length === 0 && radiosCheck) goToNextStep(btn);
    else alert('Please ensure all required fields are filled in. No minus numbers or numbers greater than 9999 are allowed.')
    updateSummary();
};

const goToNextStep = (btn: HTMLButtonElement) => {
    const container = btn.closest('.SGS-card') as HTMLElement;
    const currentHeader = container.querySelector('.SGS-card-header') as HTMLElement;
    const nextStep = container.nextElementSibling as HTMLElement;
    const nextHeader = nextStep.querySelector('.SGS-card-header') as HTMLElement;
    
    if (nextStep) {
        nextStep.classList.remove('disabled');
        scrollIntoView(document.querySelector('.gasstrut-heading'));
        currentHeader.click();
        container.classList.add('completed');
        setTimeout(() => { nextHeader.click(); }, 500);
    } else {
        container.classList.remove('completed');
        nextStep.classList.add('disabled');
    }
};

const updateSummary = () => {
    const summary = document.querySelector('.gasstrut-summary') as HTMLElement;
    const completedSteps = document.querySelectorAll('.SGS-card.completed') as NodeListOf<HTMLElement>;
    const summaryList = summary.querySelector('ul') as HTMLElement;
    
    summaryList.innerHTML = '';

    completedSteps.forEach(step => {
        const inputs = step.querySelectorAll('input:not([type="radio"])') as NodeListOf<HTMLInputElement>;
        inputs.forEach(input => {
            const inputName = input.placeholder != "" ? input.placeholder : input.name;
            const inputValue = input.value;
            const listItem = document.createElement('li');
            if (inputValue != "") {
                listItem.innerHTML = `<span>${inputName}:</span><strong>${inputValue}</strong>`;
                summaryList.appendChild(listItem);
            }            
        });

        const hasRadios = step.querySelectorAll('input[type="radio"]') as NodeListOf<HTMLInputElement>;
        if (hasRadios && hasRadios.length > 0) {
            const checkedRadio = step.querySelector('input[type="radio"]:checked') as HTMLInputElement;
            if (checkedRadio) {
                const listItem = document.createElement('li');
                listItem.innerHTML = `<span>${checkedRadio.name}:</span><strong>${checkedRadio.value}</strong>`;
                summaryList.appendChild(listItem);
            }
            
        };
    });

    if (completedSteps.length === 0) summary.classList.add('d-none');
    else summary.classList.remove('d-none');
};

const formSubmission = () => {
    const form = document.querySelector<HTMLFormElement>('.gasstrut-form');    
    form?.addEventListener('submit', e => {
        e.preventDefault();
        const detailInputs = form.querySelectorAll('.SGS-card--details input:required') as NodeListOf<HTMLInputElement>;
        detailInputs.forEach(input => {
            if (input.value === '') input.classList.add('is-invalid');
            else input.classList.remove('is-invalid');
        });
        const invalidInputs = form.querySelectorAll('.SGS-card--details input.is-invalid') as NodeListOf<HTMLInputElement>; 
        const openHeader = document.querySelector('.SGS-card-header[aria-expanded="true"]');
        const offset = isMobile() ? 100 : 150;
        if (invalidInputs.length > 0) scrollIntoView(openHeader, { scrollUp: offset, scrollDown: offset });
        if (invalidInputs.length === 0) {
            const formTitle = form.dataset.title ? form.dataset.title : "Gas Strut form";
            gaTracking('form_submit', false, {
                method: "Site form",
                form_name: formTitle
            });
            form.submit();            
        }        
    });
};

const toggleSummary = () => {
    const summary = document.querySelector('.gasstrut-summary') as HTMLElement;
    const summaryToggle = document.querySelector('.gasstrut-summary h4') as HTMLElement;
    summaryToggle?.addEventListener('click', () => { summary.classList.toggle('show'); });
}; 

const rodEndFixingOptions = () => {
    const options = document.querySelectorAll('.fixing-toggle') as NodeListOf<HTMLInputElement>;
    if (options) {
        options.forEach(option => {
            option.addEventListener('click', e => {
                const selectedType = option.dataset.type;
                const selectedOptions = option.closest('.SGS-card-body').querySelectorAll(`.form-group[data-type="${selectedType}"]`) as NodeListOf<HTMLElement>;
                const allOptions = option.closest('.SGS-card-body').querySelectorAll(`.form-group`) as NodeListOf<HTMLElement>;
                if (selectedOptions) {
                    allOptions.forEach(opt => {
                        opt.classList.add('d-none');
                        const inputs = opt.querySelectorAll('input') as NodeListOf<HTMLInputElement>;
                        inputs.forEach(input => { input.removeAttribute('required'); });
                    });
                    selectedOptions?.forEach(selected => {
                        selected.classList.remove('d-none');
                        const inputs = selected.querySelectorAll('input') as NodeListOf<HTMLInputElement>;
                        inputs.forEach(input => { input.setAttribute('required', 'required'); });
                    });
                }
            });
        });
    }
};

const handleNumberInputs = () => {
    const inputs = document.querySelectorAll<HTMLElement>('.js-number-input');
    inputs.forEach(input => {
        input.addEventListener('keydown', (e) => {
            const element = e.target as HTMLInputElement;
            if (isFinite(+e.key) && element.value.length >= +element.maxLength) e.preventDefault();
        })
    })
};

const exit = () => {
    console.log("Gas Strut: Exit");
};

window.gasstrut = {
    init,
    exit
};